import { UtilitySectionData } from "../../types";

import Styled from "./index.styles";

export default function UtilityCardHeader({
  title,
  description,
  sequence,
}: Pick<UtilitySectionData, "title" | "description"> & { sequence: number }) {
  return (
    <Styled.utilityCardHeader
      className="utility-card-header"
      sequence={sequence}
    >
      <h3 className="utility-card-title">{title}</h3>

      <p className="utility-card-description">{description}</p>
    </Styled.utilityCardHeader>
  );
}
